import { BetaButton } from './BetaButton';
import { jsx as _jsx } from "react/jsx-runtime";
export const MinimizedBetaButton = ({
  children,
  icon = 'none',
  onClick
}) => {
  return /*#__PURE__*/_jsx(BetaButton, {
    icon: icon,
    minimized: true,
    onClick: onClick,
    children: children
  });
};

// Temporary for backwards compatibility
export default MinimizedBetaButton;